import { FC } from 'react';
import { Radio, Typography } from 'antd';
import styled from 'styled-components';
import { useGetPayloadWithProvided } from '~/controllers/wizard';
import { DocumentInput, Collapse } from '~/components';
import { useTranslation } from 'react-i18next';
import Form from '~/components/WizardForm';
import buildNamePath from '~/utils/buildNamePath';

const n = buildNamePath('shareholders');

const ShareholdersProofs: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const payload = useGetPayloadWithProvided();
  return (
    <>
      {payload?.proofRequired && (
        <StyledCollapse ghost className="TitleWithCollapse" defaultActiveKey={['proofRequired']}>
          <Collapse.Panel
            key="proofRequired"
            showArrow
            header={
              <Typography.Title level={4}>
                {t('Shareholder Proof Document').toUpperCase()}
              </Typography.Title>
            }
          >
            <Form.Item name={n(['proof', 'type'])}>
              <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Radio value="MEMORANDUM">{t('Memorandum of Association')}</Radio>
                <Radio value="ARTICLES">{t('Articles of Association')}</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name={n(['proof', 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
          </Collapse.Panel>
        </StyledCollapse>
      )}
      {payload?.minutesOfBoardMeetingsRequired && (
        <StyledCollapse
          ghost
          className="TitleWithCollapse"
          defaultActiveKey={['minutesOfBoardMeetingsRequired']}
        >
          <Collapse.Panel
            key="minutesOfBoardMeetingsRequired"
            showArrow
            header={
              <Typography.Title level={4}>
                {t('Minutes of board meetings').toUpperCase()}
              </Typography.Title>
            }
          >
            <Typography.Paragraph>
              {t('Please upload a scan or a photo of Minutes of Board Meetings')}
            </Typography.Paragraph>
            <Form.Item name={n(['minutesOfBoardMeetings', 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
          </Collapse.Panel>
        </StyledCollapse>
      )}
      {payload?.jointStockCompaniesDataRequired && (
        <StyledCollapse
          ghost
          className="TitleWithCollapse"
          defaultActiveKey={['jointStockCompaniesDataRequired']}
        >
          <Collapse.Panel
            key="jointStockCompaniesDataRequired"
            showArrow
            header={
              <Typography.Title level={4}>
                {t('Data of joint-stock companies listed in the financial market').toUpperCase()}
              </Typography.Title>
            }
          >
            <Typography.Paragraph>
              {t(
                'Please upload a scan or a photo of Data of joint-stock companies listed in the financial market'
              )}
            </Typography.Paragraph>
            <Form.Item name={n(['jointStockCompaniesData', 'files'])}>
              <DocumentInput name="photos" variant="default" />
            </Form.Item>
          </Collapse.Panel>
        </StyledCollapse>
      )}
    </>
  );
};

const StyledCollapse = styled(Collapse)`
  .ant-collapse-header {
    padding: 0 !important;
    text-transform: unset;
    font-size: 14px;
  }
  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export default ShareholdersProofs;
